import { Svg } from 'ui/Svg'
import WarningIcon from 'images/dashboard/warning-icon.svg'
import { Text } from 'theme-ui'
import React, { ReactElement } from 'react'

export default function NotificationIconAndMessage({ message }: { message: string }): ReactElement {
  return (
    <>
      <Svg svg={WarningIcon} descriptiveText="Warning icon" />
      <Text
        variant="size15Weight400Line138"
        sx={{
          mt: '1.2rem',
        }}
      >
        {message}
      </Text>
    </>
  )
}
